import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    city:'',
    text:'',
    mound:false,
    token:'',
    nickname:'',
    supid:'',
  },
  mutations: {
    tokenMon(state,payload){
      state.token=payload
    },
    nicknameMon(state,payload){
      state.nickname=payload
    },
    supidMib(state,payload){
      state.supid=payload
    },
    mapAdd(state,payload){
      state.city+=payload
    },
    mapText(state,payload){
      state.text=payload
    },
    mapmound(state,payload){
      state.mound=payload
    },
     
  },
  actions: {
  },
  modules: {
  }
})
